module.exports = __webpack_public_path__ + "img/icon-zoom-in.dc2afce8.svg";